import { enableProdMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {AuthInterceptor} from './app/services/auth.interceptor';
import { Api } from './app/services/api'; // adjust path
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import esMX from '@angular/common/locales/es-MX'; // or: import es from '@angular/common/locales/es';
import { MEXICO_DATE_FORMATS, MexicoDateAdapter } from './app/mexico-date-adapter';

if (environment.production) {
  enableProdMode();
}
registerLocaleData(esMX); // <-- must run BEFORE bootstrap

bootstrapApplication(AppComponent, {
  providers: [{ provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
    // ← ADD THESE TWO:
    { provide: DateAdapter,      useClass: MexicoDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MEXICO_DATE_FORMATS },
  //  provideNativeDateAdapter(),   // ✅ gives the datepicker a DateAdapter
    importProvidersFrom(BrowserModule, AppRoutingModule),
    provideAnimations(),
       Api,
    provideHttpClient(
      withInterceptors([
        (req, next) => {
          const token = localStorage.getItem('access_token');
// console.log('🔐 Intercepting request with token:', token);
          // Validar si el token ha expirado
          if (token) {
            try {
              const payload = JSON.parse(atob(token.split('.')[1])); // decode payload
              const now = Math.floor(Date.now() / 1000);

              if (payload.exp && payload.exp > now) {
                // Token válido y no expirado
                const cloned = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${token}`
                  }
                });
                return next(cloned);
              } else {
                console.warn('⏰ Token expirado');
                localStorage.removeItem('access_token'); // Opcional: limpia token
              }
            } catch (e) {
              console.error('❌ Token mal formado:', e);
              localStorage.removeItem('access_token');
            }
          }

          // Si no hay token o es inválido/expirado
          return next(req);
        }
      ])
    )
  ]
}).catch((err) => console.error(err));
